import { makeUrl } from "src/routes/makeUrl";
import React from "react";
import { PageUrl } from "src/routes/PageUrl";
import { Link } from "react-router-dom";
import { ATVTemplateToken } from "../types";
import { atvTokenStd } from "./atvTokenStd";

export const atvTokenWithBlankLink: ATVTemplateToken = {
  item(baseProps, row, rowKey, dynamicProps) {
    return (
      <Link
        style={{ color: "inherit" }}
        to={`${makeUrl(PageUrl.entityCard, { id: String(row[rowKey]) })}`}
      >
        {atvTokenStd.item(baseProps, row, rowKey, dynamicProps)}
      </Link>
    );
  },
};
